export const CLASSE_POPUP_LIBERADO = 'driver-popup-liberado'
export const CLASSE_POPUP_NA_CAMADA_SUPERIOR = 'driver-popup-camada-superior'

const CLASSE_TOUR_ATIVO = 'driver-active'
const SELETOR_POPUP_LIBERADO = `.${CLASSE_POPUP_LIBERADO}`
const SELETOR_POPUP_NA_CAMADA_SUPERIOR = `.${CLASSE_POPUP_NA_CAMADA_SUPERIOR}`
const SELETORES_POPUP_DE_TERCEIROS = [
  '.ui-autocomplete',
  '.ui-datepicker',
  '.selectize-dropdown',
  '.select2-dropdown',
  '.daterangepicker',
  '.dropdown-menu.show'
].join(', ')
const POSICOES_QUE_EMPILHAM_SEMPRE = ['fixed', 'sticky']
const DISPLAYS_DE_CONTAINER_FLEX_OU_GRID = ['flex', 'inline-flex', 'grid', 'inline-grid']
const CONTAIN_QUE_EMPILHA = /paint|layout|strict|content/
const WILL_CHANGE_QUE_EMPILHA = /transform|opacity|filter|perspective|isolation/
const ESTILOS_PRESERVADOS_NA_CAMADA_SUPERIOR = [
  ['--tour-popup-padding', 'padding'],
  ['--tour-popup-borda-largura', 'border-width'],
  ['--tour-popup-borda-estilo', 'border-style'],
  ['--tour-popup-borda-cor', 'border-color'],
  ['--tour-popup-fundo', 'background-color'],
  ['--tour-popup-cor', 'color'],
  ['--tour-popup-overflow', 'overflow']
]

function popupVisivel(no) {
  if (no.hidden) return false
  const estilo = window.getComputedStyle(no)
  return estilo.display !== 'none' && estilo.visibility !== 'hidden'
}

function popupQualifica(no) {
  return no.matches(SELETORES_POPUP_DE_TERCEIROS) && popupVisivel(no)
}

function valorAtivo(valor, neutro) {
  return Boolean(valor) && valor !== neutro
}

function filhoDeFlexOuGrid(no) {
  const pai = no.parentElement
  return Boolean(pai) && DISPLAYS_DE_CONTAINER_FLEX_OU_GRID.includes(window.getComputedStyle(pai).display)
}

function criaContextoDeEmpilhamento(no) {
  const estilo = window.getComputedStyle(no)
  if (POSICOES_QUE_EMPILHAM_SEMPRE.includes(estilo.position)) return true
  if (valorAtivo(estilo.zIndex, 'auto') && (valorAtivo(estilo.position, 'static') || filhoDeFlexOuGrid(no))) return true

  return (estilo.opacity !== '' && Number(estilo.opacity) < 1) ||
    valorAtivo(estilo.transform, 'none') ||
    valorAtivo(estilo.filter, 'none') ||
    estilo.isolation === 'isolate' ||
    CONTAIN_QUE_EMPILHA.test(estilo.contain || '') ||
    WILL_CHANGE_QUE_EMPILHA.test(estilo.willChange || '')
}

function presoEmContextoDeEmpilhamento(popup) {
  for (let no = popup.parentElement; no && no !== document.body; no = no.parentElement) {
    if (criaContextoDeEmpilhamento(no)) return true
  }
  return false
}

function suportaCamadaSuperior(no) {
  return typeof no.showPopover === 'function' && typeof no.hidePopover === 'function'
}

function definirVariavel(no, nome, valor) {
  if (no.style.getPropertyValue(nome) === valor) return
  no.style.setProperty(nome, valor)
}

function sairDaCamadaSuperior(popup) {
  if (!popup.classList.contains(CLASSE_POPUP_NA_CAMADA_SUPERIOR)) return
  popup.hidePopover()
  popup.removeAttribute('popover')
  popup.classList.remove(CLASSE_POPUP_NA_CAMADA_SUPERIOR)
}

function removerVariaveisDaCamadaSuperior(popup) {
  ['--tour-popup-topo', '--tour-popup-esquerda', '--tour-popup-largura']
    .concat(ESTILOS_PRESERVADOS_NA_CAMADA_SUPERIOR.map(([variavel]) => variavel))
    .forEach((variavel) => popup.style.removeProperty(variavel))
}

function entrarNaCamadaSuperior(popup) {
  const retangulo = popup.getBoundingClientRect()
  const estilo = window.getComputedStyle(popup)
  definirVariavel(popup, '--tour-popup-topo', `${retangulo.top}px`)
  definirVariavel(popup, '--tour-popup-esquerda', `${retangulo.left}px`)
  definirVariavel(popup, '--tour-popup-largura', `${retangulo.width}px`)
  ESTILOS_PRESERVADOS_NA_CAMADA_SUPERIOR.forEach(([variavel, propriedade]) => {
    definirVariavel(popup, variavel, estilo.getPropertyValue(propriedade))
  })
  popup.setAttribute('popover', 'manual')
  popup.classList.add(CLASSE_POPUP_NA_CAMADA_SUPERIOR)
  popup.showPopover()
}

function posicionarAcimaDaCortina(popup) {
  if (!suportaCamadaSuperior(popup)) return
  sairDaCamadaSuperior(popup)
  if (presoEmContextoDeEmpilhamento(popup)) entrarNaCamadaSuperior(popup)
}

function devolverPopup(popup) {
  sairDaCamadaSuperior(popup)
  removerVariaveisDaCamadaSuperior(popup)
  popup.classList.remove(CLASSE_POPUP_LIBERADO)
}

export function limparPopupsLiberados() {
  document
    .querySelectorAll(`${SELETOR_POPUP_LIBERADO}, ${SELETOR_POPUP_NA_CAMADA_SUPERIOR}`)
    .forEach(devolverPopup)
}

export function sincronizarPopupsLiberados() {
  if (!document.body.classList.contains(CLASSE_TOUR_ATIVO)) {
    limparPopupsLiberados()
    return
  }

  document.querySelectorAll(`${SELETOR_POPUP_LIBERADO}, ${SELETOR_POPUP_NA_CAMADA_SUPERIOR}`).forEach((no) => {
    if (!popupQualifica(no)) devolverPopup(no)
  })

  document.querySelectorAll(SELETORES_POPUP_DE_TERCEIROS).forEach((no) => {
    if (!popupQualifica(no)) return
    no.classList.add(CLASSE_POPUP_LIBERADO)
    posicionarAcimaDaCortina(no)
  })
}
